import { Card, message, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { handleAuth } from '../core/auth';
import { routeConfig } from '../shared/common/constant';
import { ConfirmUser } from '../shared/common/graphqlQuery';
import AccountPageShowBrand from '../shared/components/accountPageShowBrand/accountPageBrand';
import { useMutationHook } from '../shared/hooks/useMutationHook';

const ConfrimEmailComponent = () => {
    const { confirmToken } = useParams<any>();
    const history = useHistory();
    const goTOUrl = (url) => { history.push(url); }

    const onSubmitted = (result: any) => {
        setTimeout(() => {
            handleAuth(result.confirmUser);
            goTOUrl(routeConfig.createCompany.path);
            message.success('User successfully confirmed. Welcome to Export Docs!')
        }, 2000);
    }

    useEffect(() => {
        if (confirmToken) {
            callMutation({ variables: { confirmationToken: confirmToken } })
        }
    }, [confirmToken]);

    const onError = ({ graphQLErrors, networkError }: any) => {
        console.log(graphQLErrors, 'mymy');
        message.error(graphQLErrors[0].message);
        setTimeout(() => {
            goTOUrl(routeConfig.login.path);
        }, 1000);
    }

    const { callMutation, loading } = useMutationHook(ConfirmUser, onSubmitted, onError);

    return (
        <div className="center">
            <div className="card">
                <AccountPageShowBrand />
                <Card bordered={false} className='loginForm'>
                    <Spin style={{ marginRight: 10 }} /> Please wait while confirming User.
                </Card>
            </div>
        </div>
    );
}
export default ConfrimEmailComponent

